<template>
  <section>
    <Feature :title="$t('MASTER_DATA_MAINTAIN')" :iconClass="'fa-database'">
      <FormRow :fieldNameArr="[$t('MASTER_CLASS_NAME')]">
        <Select filterable v-model="masterDataCategory" @on-change="search" style="width: 200px" slot="a">
          <Option v-for="(item, index) in masterDataCategoryList" :value="item.masterDataCategory" :key="index">{{ item.masterDataCategory }}</Option>
        </Select>
        <Button type="primary" @click="showModal = true" slot="b">{{ $t('ADD') }}</Button>
      </FormRow>
      <TablePage
        :border="true"
        :tableWidth="windowWidth"
        :columnsList="showColumns"
        :resultList="showData"
      ></TablePage>
    </Feature>
    <Modal
      v-model="showModal"
      :z-index="modalSize"
      :reset-drag-position="true"
      :draggable="true"
      :title="saveData.uuid === '' ? $t('ADD') : $t('UPDATE')"
      :ok-text="$t('SAVE')"
      @on-ok="save"
      @on-cancel="resetModal"
    >
      <Form :model="saveData" :label-width="100">
        <Form-item v-if="masterDataCategory === 'HIGH_PRICE_REASON_CATEGORY'" :label="$t('HIGH_PRICE_REASON_CATEGORY')">
          <Input v-model="saveData.highPriceReasonCategory" />
        </Form-item>
        <Form-item v-if="masterDataCategory === 'RAW_MATERIAL'" :label="$t('RAW_MATERIAL_TYPE')">
          <Input v-model="saveData.type" :maxlength="100" />
        </Form-item>
        <Form-item v-if="masterDataCategory === 'RAW_MATERIAL'" :label="$t('RAW_MATERIAL_UNIT')">
          <Input v-model="saveData.unit" :maxlength="20" />
        </Form-item>
        <Form-item :label="$t('ENABLED')">
          <i-switch v-model="saveData.enabled" size="large">
            <span slot="open">{{ $t("YES") }}</span>
            <span slot="close">{{ $t("NO") }}</span>
          </i-switch>
        </Form-item>
      </Form>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { Translate, ExceptionHandling } from "@/util/common"
import { AlertInfo } from "@/util/alert"

export default {
  name: "MasterData",
  created() {
    const vueInstance = this;
    vueInstance.$quotationHttp
      .get("/master-data-category")
      .then(response => {
        if (!response.data) {
          vueInstance.$Swal.fire({
            icon: "info",
            title: Translate("COMMON_MESSAGE_ERROR"),
            text: "Master Data Category: " + Translate("COMMON_TEXT_NOTHING"),
          });
          return;
        }
        response.data.forEach(masterDataCategory => {
          vueInstance.masterDataCategoryList.push({
            "uuid": masterDataCategory.uuid,
            "masterDataCategory": masterDataCategory.masterDataCategory
          })
        });
        vueInstance.search();
      })
      .catch(error => {
        vueInstance.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          html: ExceptionHandling(error.response),
        })
      });
  },
  data() {
    return {
      masterDataCategoryList: [],
      masterDataCategory: "RAW_MATERIAL",
      rawMaterialList: [],
      highPriceReasonCategoryList: [],
      showModal: false,
      saveData: {
        uuid: "",
        enabled: true,
        type: "",
        unit: "",
        highPriceReasonCategory: ""
      }
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    search() {
      const vueInstance = this;
      vueInstance.toggleLoading(true);
      switch (vueInstance.masterDataCategory) {
        case "RAW_MATERIAL":
          vueInstance.$quotationHttp
            .get("/master-data/" + vueInstance.masterDataCategory + "/disc")
            .then(response => {
              if (!response.data._embedded) {
                Swal.fire({
                  icon: "info",
                  title: Translate("COMMON_MESSAGE_ERROR"),
                  text: "Raw Material: " + Translate("COMMON_TEXT_NOTHING"),
                });
                return;
              }
              vueInstance.rawMaterialList.length = 0;
              response.data._embedded.rawMaterialResourceList.forEach(rawMaterial => {
                vueInstance.rawMaterialList.push({
                  "uuid": rawMaterial.uuid,
                  "enabled": rawMaterial.enabled,
                  "type": rawMaterial.type,
                  "unit": rawMaterial.unit,
                  "updateDate": rawMaterial.lastModified === undefined ? rawMaterial.created : rawMaterial.lastModified
                });
              });
            })
            .catch(error => {
              let text = ExceptionHandling(error.response)
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                html: text,
              })
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
        case "HIGH_PRICE_REASON_CATEGORY":
          vueInstance.$quotationHttp
            .get("/high-price-reason-category")
            .then(response => {
              if (!response.data._embedded) {
                Swal.fire({
                  icon: "info",
                  title: Translate("COMMON_MESSAGE_ERROR"),
                  text: "High Price Reason Category: " + Translate("COMMON_TEXT_NOTHING"),
                });
                return;
              }
              vueInstance.highPriceReasonCategoryList.length = 0;
              response.data._embedded.highPriceReasonCategoryResourceList.forEach(highPriceReasonCategory => {
                vueInstance.highPriceReasonCategoryList.push({
                  "uuid": highPriceReasonCategory.uuid,
                  "enabled": highPriceReasonCategory.enabled,
                  "highPriceReasonCategory": highPriceReasonCategory.highPriceReasonCategory,
                  "updateDate": highPriceReasonCategory.lastModified === undefined ? highPriceReasonCategory.created : highPriceReasonCategory.lastModified
                });
              });
            })
            .catch(error => {
              let text = ExceptionHandling(error.response)
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                html: text,
              })
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
      }
    },
    edit(row) {
      const vueInstance = this;
      vueInstance.showModal = true;
      vueInstance.saveData.uuid = row.uuid;
      vueInstance.saveData.enabled = row.enabled;
      vueInstance.saveData.type = row.type;
      vueInstance.saveData.unit = row.unit;
      vueInstance.saveData.highPriceReasonCategory = row.highPriceReasonCategory;
    },
    save() {
      const vueInstance = this;
      switch (vueInstance.masterDataCategory) {
        case "RAW_MATERIAL":
          let errorMessage = "";
          if (!vueInstance.saveData.type) {
            errorMessage = errorMessage + vueInstance.$t("PLEASE_KEY_IN") + vueInstance.$t("RAW_MATERIAL_TYPE") + " <br>";
          }
          if (!vueInstance.saveData.unit) {
            errorMessage = errorMessage + vueInstance.$t("PLEASE_KEY_IN") + vueInstance.$t("RAW_MATERIAL_UNIT") + " <br>";
          }
          if (errorMessage) {
            AlertInfo(vueInstance, errorMessage)
              .then(() => {});
            return;
          }
          if (vueInstance.saveData.uuid === "") {
            vueInstance.$quotationHttp
              .post("/master-data/RAW_MATERIAL/create", vueInstance.saveData)
              .then(response => {
                vueInstance.search();
                vueInstance.resetModal();
                AlertInfo(vueInstance, vueInstance.$t("CREATE_SUCCESS"))
                  .then(() => {});
              })
              .catch(error => {
                console.log(error);
                vueInstance.$Swal.fire({
                  icon: "error",
                  title: Translate("COMMON_MESSAGE_ERROR"),
                  html: ExceptionHandling(error.response),
                });
              })
              .finally(() => {
                vueInstance.toggleLoading(false);
              });
          } else {
            vueInstance.$quotationHttp
              .post("/master-data/RAW_MATERIAL/update", vueInstance.saveData)
              .then(response => {
                vueInstance.search();
                vueInstance.resetModal();
                AlertInfo(vueInstance, vueInstance.$t("UPDATE_SUCCESS"))
                  .then(() => {});
              })
              .catch(error => {
                console.log(error);
                vueInstance.$Swal.fire({
                  icon: "error",
                  title: Translate("COMMON_MESSAGE_ERROR"),
                  html: ExceptionHandling(error.response),
                });
              })
              .finally(() => {
                vueInstance.toggleLoading(false);
              });
          }
          break;
        case "HIGH_PRICE_REASON_CATEGORY":
          if (vueInstance.saveData.highPriceReasonCategory === "") {
            AlertInfo(vueInstance, vueInstance.$t("PLEASE_KEY_IN") + vueInstance.$t("HIGH_PRICE_REASON_CATEGORY"))
              .then(() => {});
            return;
          }
          vueInstance.toggleLoading(true);
          if (vueInstance.saveData.uuid === "") {
            vueInstance.$quotationHttp
              .post("/high-price-reason-category", vueInstance.saveData)
              .then(response => {
                vueInstance.search();
                vueInstance.resetModal();
                AlertInfo(vueInstance, vueInstance.$t("CREATE_SUCCESS"))
                  .then(() => {});
              })
              .catch(error => {
                console.log(error);
                vueInstance.$Swal.fire({
                  icon: "error",
                  title: Translate("COMMON_MESSAGE_ERROR"),
                  html: ExceptionHandling(error.response),
                });
              })
              .finally(() => {
                vueInstance.toggleLoading(false);
              });
          } else {
            vueInstance.$quotationHttp
              .patch("/high-price-reason-category/" + vueInstance.saveData.uuid, vueInstance.saveData)
              .then(response => {
                vueInstance.search();
                vueInstance.resetModal();
                AlertInfo(vueInstance, vueInstance.$t("UPDATE_SUCCESS"))
                  .then(() => {});
              })
              .catch(error => {
                console.log(error);
                vueInstance.$Swal.fire({
                  icon: "error",
                  title: Translate("COMMON_MESSAGE_ERROR"),
                  html: ExceptionHandling(error.response),
                });
              })
              .finally(() => {
                vueInstance.toggleLoading(false);
              });
          }
          break;
      }
    },
    resetModal() {
      const vueInstance = this;
      vueInstance.saveData.uuid = "";
      vueInstance.saveData.enabled = true;
      vueInstance.saveData.type = "";
      vueInstance.saveData.unit = "";
      vueInstance.saveData.highPriceReasonCategory = "";
    },
    enable(uuid) {
      const vueInstance = this;
      vueInstance.toggleLoading(true);
      switch (vueInstance.masterDataCategory) {
        case "RAW_MATERIAL":
          vueInstance.$quotationHttp
            .patch("/master-data/RAW_MATERIAL/" + uuid + "/enable")
            .then(response => {
              if (!response.data) {
                return;
              }
              let rawMaterial = vueInstance.rawMaterialList.find(e => e.uuid === uuid);
              rawMaterial.enabled = response.data.enabled;
              rawMaterial.updateDate = response.data.lastModified;
            })
            .catch(error => {
              console.log(error);
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                html: ExceptionHandling(error.response),
              });
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
        case "HIGH_PRICE_REASON_CATEGORY":
          vueInstance.$quotationHttp
            .patch("/high-price-reason-category/" + uuid + "/enable")
            .then(response => {
              if (!response.data) {
                return;
              }
              let highPriceReasonCategory = vueInstance.highPriceReasonCategoryList.find(e => e.uuid === uuid);
              highPriceReasonCategory.enabled = response.data.enabled;
              highPriceReasonCategory.updateDate = response.data.lastModified;
            })
            .catch(error => {
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                html: ExceptionHandling(error.response),
              })
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
      }
    },
    disable(uuid) {
      const vueInstance = this;
      vueInstance.toggleLoading(true);
      switch (vueInstance.masterDataCategory) {
        case "RAW_MATERIAL":
          vueInstance.$quotationHttp
            .patch("/master-data/RAW_MATERIAL/" + uuid + "/disable")
            .then(response => {
              if (!response.data) {
                return;
              }
              let rawMaterial = vueInstance.rawMaterialList.find(e => e.uuid === uuid);
              rawMaterial.enabled = response.data.enabled;
              rawMaterial.updateDate = response.data.lastModified;
            })
            .catch(error => {
              console.log(error);
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                html: ExceptionHandling(error.response),
              });
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
        case "HIGH_PRICE_REASON_CATEGORY":
          vueInstance.$quotationHttp
            .patch("/high-price-reason-category/" + uuid + "/disable")
            .then(response => {
              if (!response.data) {
                return;
              }
              let highPriceReasonCategory = vueInstance.highPriceReasonCategoryList.find(e => e.uuid === uuid);
              highPriceReasonCategory.enabled = response.data.enabled;
              highPriceReasonCategory.updateDate = response.data.lastModified;
            })
            .catch(error => {
              vueInstance.$Swal.fire({
                icon: "error",
                title: Translate("COMMON_MESSAGE_ERROR"),
                html: ExceptionHandling(error.response),
              })
            })
            .finally(() => {
              vueInstance.toggleLoading(false);
            });
          break;
      }
    }
  },
  computed: {
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    },
    showColumns() {
      switch (this.masterDataCategory) {
        case "RAW_MATERIAL":
          return [{
            title: this.$t("COMMON_BUTTON_operation"),
            width: 120,
            align: "center",
            render: (h, params) => {
              return h("Icon", {
                props: {
                  type: "md-create",
                  size: 28,
                },
                class: "text-delta-blue",
                on: {
                  click: () => {
                    this.edit(params.row)
                  },
                },
              });
            }
          }, {
            title: this.$t('ENABLED'),
            width: 120,
            sortable: true,
            align: "center",
            render: (h, params) => {
              return h("Icon", {
                props: {
                  type: params.row.enabled ? "md-checkmark-circle" : "md-close-circle",
                  size: 28
                },
                class: params.row.enabled ? "text-delta-blue" : "text-delta-red",
                on: {
                  click: () => {
                    if (params.row.enabled) {
                      this.disable(params.row.uuid);
                    } else {
                      this.enable(params.row.uuid);
                    }
                  }
                }
              });
            }
          }, {
            title: this.$t('RAW_MATERIAL_TYPE'),
            key: "type",
            align: 'center',
            sortable: true
          }, {
            title: this.$t('RAW_MATERIAL_UNIT'),
            key: "unit",
            align: 'center',
            sortable: true
          }, {
            title: this.$t('UPDATE_DATE'),
            key: "updateDate",
            align: 'center',
            sortable: true
          }];
        case "HIGH_PRICE_REASON_CATEGORY":
          return [{
            title: this.$t("COMMON_BUTTON_operation"),
            width: 120,
            align: "center",
            render: (h, params) => {
              return h("Icon", {
                props: {
                  type: "md-create",
                  size: 28,
                },
                class: "text-delta-blue",
                on: {
                  click: () => {
                    this.edit(params.row)
                  },
                },
              });
            }
          }, {
            title: this.$t('ENABLED'),
            width: 120,
            sortable: true,
            align: "center",
            render: (h, params) => {
              return h("Icon", {
                props: {
                  type: params.row.enabled ? "md-checkmark-circle" : "md-close-circle",
                  size: 28
                },
                class: params.row.enabled ? "text-delta-blue" : "text-delta-red",
                on: {
                  click: () => {
                    if (params.row.enabled) {
                      this.disable(params.row.uuid);
                    } else {
                      this.enable(params.row.uuid);
                    }
                  }
                }
              });
            }
          }, {
            title: this.$t("HIGH_PRICE_REASON_CATEGORY"),
            key: "highPriceReasonCategory",
            sortable: true,
            width: 200,
            align: "center"
          }, {
            title: this.$t("UPDATE_DATE"),
            key: "updateDate",
            sortable: true,
            width: 120,
            align: "center"
          }];
      }
    },
    showData() {
      switch (this.masterDataCategory) {
        case "RAW_MATERIAL":
          return this.rawMaterialList;
        case "HIGH_PRICE_REASON_CATEGORY":
          return this.highPriceReasonCategoryList;
      }
    }
  }
}
</script>

<style scoped></style>
